var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ln-spin tw-absolute tw-right-1/2 tw-bottom-1/2  tw-transform tw-translate-x-1/2 tw-translate-y-1/2 "},[_c('div',{class:[
      ("tw-border-solid tw-animate-spin tw-rounded-full tw-border-blue-400 tw-border-2 tw-h-" + _vm.size + " tw-w-" + _vm.size + " tw-border-t-transparent") ]})])}
var staticRenderFns = []

export { render, staticRenderFns }